import { useEffect, useState } from "react";
import Tagify from "@yaireo/tagify";
import "@yaireo/tagify/dist/tagify.css";
import EmojiPicker from "emoji-picker-react";
import InsertEmoticonIcon from "@material-ui/icons/InsertEmoticon";

import "./TextAreaMention.scss";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const TextAreaMention = ({
  onSubmit,
  value,
  setComment,
  memberList,
  uniqueId,
}) => {
  useEffect(() => {
    if (memberList.length > 0) {
      const whitelist_1 = memberList.map((member) => ({
        title: member,
        value: member,
        text: member,
      }));

      var input = document.querySelector("[name=mix]"),
        tagify = new Tagify(input, {
          mode: "mix", // <--  Enable mixed-content
          pattern: /@/, // <--  Text starting with @ or # (if single, String can be used here)
          tagTextProp: "text", // <-- the default property (from whitelist item) for the text to be rendered in a tag element.
          // Array for initial interpolation, which allows only these tags to be used
          whitelist: whitelist_1,
          onChangeAfterBlur: false,
          editTags: false,
          enforceWhitelist: true,
          validate(data) {
            return !/[^a-zA-Z0-9 ]/.test(data.value);
          },
          dropdown: {
            enabled: 0,
            fuzzySearch: false,
            classname: "text-area-mention-dropdown",
            position: "text", // <-- render the suggestions list next to the typed text ("caret")
            mapValueTo: "text", // <-- similar to above "tagTextProp" setting, but for the dropdown items
            highlightFirst: true, // automatically highlights first sugegstion item in the dropdown
          },
        });

      tagify.on("keydown", function (e) {
        if (e.detail.event.key === "Enter" && !e.detail.event.shiftKey) {
          setTimeout(() => {
            document.getElementById(`send-button-comment-${uniqueId}`).click();
          }, 200);
        }
      });

      tagify.on("input", function (e) {
        var prefix = e.detail.prefix;

        if (prefix) {
          if (prefix === "@") tagify.whitelist = whitelist_1;
        }
      });
      tagify.on("change", function (e) {
        setComment(e.detail.tagify.state.lastOriginalValueReported);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberList, uniqueId]);

  const [emojiPicker, setEmojiPicker] = useState(false);

  return (
    <Wrapper>
      {/* <div className="textAreaMention"> */}
      <div>
        <textarea
          id="txt-comment"
          name="mix"
          placeholder="Share your thoughts..."
          type="text"
          value={value}
          // className="form-control form-control-2 "
        />

        <Actions>
          <InsertEmoticonIcon
            onClick={() => setEmojiPicker((prev) => !prev)}
            color="#fff"
          />
          <SendButton id={`send-button-comment-${uniqueId}`} onClick={onSubmit}>
            <FontAwesomeIcon icon={faPaperPlane} />
          </SendButton>
        </Actions>
      </div>

      {emojiPicker && (
        <EmojiPicker
          searchDisabled="true"
          previewConfig={{ showPreview: false }}
          onEmojiClick={(e) => {
            let newValue = value;
            if (newValue.endsWith("\n")) {
              newValue = newValue.slice(0, -1);
            }
            setComment(`${newValue}${e.emoji}`);
            setEmojiPicker(false);
          }}
          height={400}
          width="100%"
        />
      )}
    </Wrapper>
  );
};

export default TextAreaMention;

const Wrapper = styled.div`
  padding: 11px 16px 12px;
  border-top: 1px solid rgba(57, 61, 79, 0.35);

  .tagify {
    border: none;
  }

  .tagify__input {
    font-size: 13px;
    color: #fff;
  }

  .tagify__input::before {
    color: #fff;
    opacity: 0.4;
  }

  .tagify__tag__removeBtn {
    display: none;
  }

  .tagify__tag > div {
    padding: 0;
    background: #12141e;
    color: #5b53ff;
  }

  .tagify__tag > div::before {
    display: none;
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .MuiSvgIcon-root {
    font-size: 18px;
    color: #fff;
    cursor: pointer;
  }
`;

const SendButton = styled.div`
  cursor: pointer;
  background-color: #00baff;
  color: rgba(0, 0, 0, 0.8);
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  border-radius: 6px;
`;
